import * as React from 'react';
import {styled} from '@mui/material/styles';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import {
    Card,
    CardContent,
    Dialog, DialogActions, DialogContent,
    DialogTitle,
    FormControl, FormControlLabel,
    FormGroup, FormLabel,
    Grid, Radio, RadioGroup, Select, Slide,
    Stack, Switch,
    Tooltip
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useContext, useEffect, useState} from "react";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {Person2Outlined} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import LinkIcon from "@mui/icons-material/Link";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import {useTheme} from '@mui/material/styles';
import {useNavigate} from "react-router-dom";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import {AuthorizationsContext} from "../../../Context/AuthorizationsContext";
import {AUTHORIZATIONS} from "../../../Utils/authorizations";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function SidebarContent(props) {
    const {mode, setMode} = useState();
    const navigate = useNavigate();
    const {hasAuthorization} = useContext(AuthorizationsContext);


    console.log(process.env)
    const theme = useTheme();

    const [openDialogProfile, setOpenDialogProfile] = React.useState(false);
    const [openDialogInfo, setOpenDialogInfo] = React.useState(false);
    const [openDialogDisconnect, setOpenDialogDisconnect] = React.useState(false);

    useEffect(() => {
        // setLangs(_langContext.intersection(_langContext.allLangList, _langContext.availableLangList))
    }, [])


    const linkNav = [
        {
            name: 'Tableau de bord',
            link: '/dashboard',
            icon: <DashboardOutlinedIcon sx={{color: "primary.main"}}/>,
            requires: AUTHORIZATIONS.DASHBOARD,
        },
        {
            name: 'Créer un QR Code',
            link: '/create',
            icon: <AdminPanelSettingsOutlinedIcon sx={{color: "primary.main"}}/>
        },
        {
            name: 'Gestion des QR Codes',
            link: '/my-qrcodes',
            icon: <ListOutlinedIcon sx={{color: "primary.main"}}/>,
            requires: AUTHORIZATIONS.TRACKED_QRCODES,
        },
        {
            name: 'Palettes',
            link: '/palettes',
            icon: <AnalyticsOutlinedIcon sx={{color: "primary.main"}}/>,
            requires: AUTHORIZATIONS.PALETTES,
        },
        {
            name: 'Domaines',
            link: '/domains',
            icon: <AssignmentOutlinedIcon sx={{color: "primary.main"}}/>,
            requires: AUTHORIZATIONS.CUSTOM_DOMAINS,
        },
        {
            name: 'API',
            link: '/api-docs',
            icon: <VpnKeyOutlinedIcon sx={{color: "primary.main"}}/>,
            requires: AUTHORIZATIONS.API_ACCESS,
        }
    ].filter((nav) => !nav.requires || hasAuthorization(nav.requires))


    const DrawerHeader = styled('div')(({theme}) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 2),
        width: "100%",

        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }));

    const toggleDrawer = (open) => () => {
        props.setIsOpen(open);
    };

    const handleCloseDialogProfile = () => {
        setOpenDialogProfile(false);
    };
    const handleClickOpenDialogInfo = () => {
        setOpenDialogInfo(true);
    };

    const handleCloseDialogInfo = () => {
        setOpenDialogInfo(false);
    };

    const handleCloseDialogDisconnect = () => {
        setOpenDialogDisconnect(false);
    };

    console.log(theme.palette.mode)

    return (
        <>
            <Stack
                direction="column"
                justifyContent="space-between"
                // alignItems="center"
                height={'100%'}
                width={'100%'}
                spacing={0}
                sx={{
                    margin: 0,
                    padding: 0
                }}
            >

                <Box
                    sx={{
                        margin: 0,
                        padding: 0
                    }}
                >
                    <DrawerHeader>


                        {
                            props.isOpen && (
                                <>
                                    <h2 style={{color: theme.palette.primary.main}}>Menu</h2>
                                    <IconButton
                                        onClick={toggleDrawer(false)}>
                                        <ChevronLeftIcon/>
                                    </IconButton>
                                </>
                            )
                        }

                        {
                            !props.isOpen && (
                                <IconButton
                                    onClick={toggleDrawer(true)}>
                                    <ChevronRightIcon/>
                                </IconButton>
                            )
                        }
                    </DrawerHeader>
                    <Divider style={{width: props.width}}/>
                    <List>
                        {linkNav.map((nav) => (
                            <ListItem disablePadding sx={{display: 'block'}}
                                      onClick={() => navigate(nav.link)}
                            >
                                <Tooltip title={props.isOpen ? '' : nav.name} placement="left">
                                    <ListItemButton
                                        sx={{
                                            minHeight: 48,
                                            justifyContent: props.isOpen ? 'initial' : 'center',
                                            px: 2.5,
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: 0,
                                                mr: props.isOpen ? 3 : 'auto',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {nav.icon}
                                        </ListItemIcon>
                                        <Typography sx={{
                                            display: props.isOpen ? 'initial' : 'none',
                                        }} color={`sidebar.${theme.palette.mode}`}>
                                            {nav.name}
                                        </Typography>
                                    </ListItemButton>
                                </Tooltip>
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Stack>

                    <Box>
                        <Divider/>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-around"
                            alignItems="center"
                        >
                            <Grid item size={{xs:12, md:(props.isOpen?6:12)}} textAlign={'center'}>

                                <Tooltip title={props.isOpen ? '' : "Mon espace"} placement="left">
                                    <IconButton aria-label="Person2Outlined" onClick={()=>{
                                        window.location.href = process.env.REACT_APP_CLIENT_SPACE_URL
                                    }}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                    color: "primary.main"
                                                }}

                                    >

                                        <Stack
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <Person2Outlined/>
                                            {
                                                props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                    Mon espace
                                                </Typography>)
                                            }
                                        </Stack>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item  size={{xs:12, md:(props.isOpen?6:12)}} textAlign={'center'}>
                                <Tooltip title={props.isOpen ? '' : "À propos"} placement="left">
                                    <IconButton aria-label="Person2Outlined" onClick={handleClickOpenDialogInfo}
                                                sx={{
                                                    width: '100%',
                                                    borderRadius: 0,
                                                    mr: props.isOpen ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                    color: "primary.main"
                                                }}

                                    >

                                        <Stack
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"

                                        >

                                            <HelpOutlineOutlinedIcon/>
                                            {
                                                props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                                    À propos
                                                </Typography>)
                                            }
                                        </Stack>
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Divider/>

                        <Tooltip title={props.isOpen ? '' : "Déconnexion"} placement="left">
                            <IconButton aria-label="Logout"
                                        sx={{
                                            width: '100%',
                                            borderRadius: 0,
                                            mr: props.isOpen ? 3 : 'auto',
                                            justifyContent: 'center',
                                            color: "primary.main"
                                        }}
                                        onClick={() => {
                                            setOpenDialogDisconnect(true)
                                        }}
                            >
                                <Stack
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"

                                >

                                    <LogoutIcon/>
                                    {
                                        props.isOpen && (<Typography color={`sidebar.${theme.palette.mode}`}>
                                            Déconnexion
                                        </Typography>)
                                    }
                                </Stack>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Stack>
            </Stack>


            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={openDialogProfile}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseDialogProfile}
                aria-describedby="Dialog profile"

            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        {/*    fixme : a changer pour mettre la variable de nom*/}
                        Mon compte
                    </Typography>
                </DialogTitle>
                <Divider></Divider>
                <Grid container
                      spacing={3}
                      padding={2}
                >
                    <Grid item xs={8} minWidth={'325px'}>
                        <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    Paramètres
                                </Typography>
                                <Grid container
                                      direction="column"
                                      justifyContent="left"
                                      alignItems="left">
                                    <Grid item>
                                        <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={2}>
                                                <Typography variant="subtitle1">RTF</Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position" column>
                                                        <FormControlLabel
                                                            value="0"
                                                            disabled={true}
                                                            control={<Switch color="primary"/>}
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={2}>
                                                <Typography
                                                    variant="subtitle1">Langue</Typography>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Select
                                                    // value={_userContext.userlang()}
                                                    // onChange={(event) => {
                                                    //     _userContext.setUserLang(event.target.value)
                                                    // }}
                                                    fullWidth
                                                >
                                                    {/*{*/}
                                                    {/*    langs.map((lang) => (*/}
                                                    {/*        <MenuItem value={lang.code}>*/}
                                                    {/*            <Grid container direction="row"*/}
                                                    {/*                  justifyContent={'center'}*/}
                                                    {/*                  alignItems={'center'}>*/}
                                                    {/*                <Grid item xs={2}>*/}
                                                    {/*                    <img*/}
                                                    {/*                        src={'data:image/png;base64, ' + lang.image_binary}*/}
                                                    {/*                        height={'25px'}*/}
                                                    {/*                    />*/}
                                                    {/*                </Grid>*/}
                                                    {/*                <Grid item xs={10}>*/}
                                                    {/*                    {lang.name}*/}
                                                    {/*                </Grid>*/}
                                                    {/*            </Grid>*/}
                                                    {/*        </MenuItem>*/}
                                                    {/*    ))*/}
                                                    {/*}*/}

                                                </Select>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justifyContent={'center'} alignItems={'center'}>
                                        <Grid item xs={2}>
                                            <Typography
                                                variant="subtitle1">mode</Typography>
                                        </Grid>
                                        <Grid item xs={10}>
                                            <FormControl>
                                                <FormLabel id="demo-theme-toggle">Theme</FormLabel>
                                                <RadioGroup
                                                    aria-labelledby="demo-theme-toggle"
                                                    name="theme-toggle"
                                                    row
                                                    value={mode}
                                                    onChange={(event) => setMode(event.target.value)}
                                                >
                                                    <FormControlLabel value="system" control={<Radio/>} label="System"/>
                                                    <FormControlLabel value="light" control={<Radio/>} label="Light"/>
                                                    <FormControlLabel value="dark" control={<Radio/>} label="Dark"/>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs minWidth={'200px'}>
                        <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                            <CardContent>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}>
                                    <LinkIcon sx={{color: 'primary.main'}}/>
                                    <Typography variant="h5" component="div">
                                        Liens utiles
                                    </Typography>
                                </Box>
                                <List>
                                    <Button
                                        style={{
                                            width: '100%',
                                            marginTop: '10px'
                                        }}
                                        variant="outlined"
                                        color="primary"
                                        href="#outlined-buttons">
                                        Boutique
                                    </Button>
                                    <Button style={{
                                        width: '100%',
                                        marginTop: '10px'
                                    }}
                                            variant="outlined"
                                            color="primary"
                                            href="#outlined-buttons">
                                        CGU
                                    </Button>
                                    <Button style={{
                                        width: '100%',
                                        marginTop: '10px'
                                    }}
                                            variant="outlined"
                                            color="primary"
                                            href="#outlined-buttons">
                                        FAQ
                                    </Button>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <DialogActions sx={{
                    justifyContent: 'flex-start'
                }}>
                    <Button color="primary"
                            onClick={() => {
                                handleCloseDialogProfile()
                                setOpenDialogDisconnect(true)
                            }}>Déconnexion</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={openDialogInfo}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseDialogInfo}
                aria-describedby="Dialog profile"

            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        À propos
                    </Typography>
                </DialogTitle>
                <Divider></Divider>

                <Card elevation={0} style={{border: '1px solid #b2b2b2'}}>
                    <CardContent>
                        <List>
                            <Button style={{
                                width: '100%',
                                marginTop: '10px'
                            }}
                                    variant="outlined"
                                    color="primary"
                                    href="#outlined-buttons">
                                CGV
                            </Button>
                            <Button style={{
                                width: '100%',
                                marginTop: '10px'
                            }}
                                    variant="outlined"
                                    color="primary"
                                    href="#outlined-buttons">
                                CGU
                            </Button>
                            <Button style={{
                                width: '100%',
                                marginTop: '10px'
                            }}
                                    variant="outlined"
                                    color="primary"
                                    href="#outlined-buttons">
                                Documentation
                            </Button>
                        </List>
                    </CardContent>
                </Card>

                <DialogActions sx={{
                    justifyContent: 'flex-start'
                }}/>
            </Dialog>

            <Dialog open={openDialogDisconnect} fullWidth={true} width={'md'}
            onClose={handleCloseDialogDisconnect}
            >
                <DialogTitle>
                    <Typography gutterBottom variant="h4" component="div">
                        Déconnexion
                    </Typography>

                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom component="div">
                        Voulez-vous vraiment vous déconnecter ?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button className={'Md-Button-color'} onClick={()=>{
                        // _tokenContext.disconnect()
                        // window.location.href = 'https://security.alais-studio.fr/auth/disconnect'
                    }}>Oui</Button>
                    <Button className={'Md-Button-color'} onClick={handleCloseDialogDisconnect}>Non</Button>
                </DialogActions>
            </Dialog>

        </>
    )
}